import { Add, ManageAccounts, Remove } from "@mui/icons-material";
import { IconButton, List, useTheme } from "@mui/material";
import { Profile } from "@readyfit-common/models";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  selectCurrentOrgID,
  selectCurrentUser,
  setCurrentOrgID,
} from "src/store/reducers/auth/authSlice";
import {
  selectShowDrawer,
  toggleDrawer,
} from "src/store/reducers/navigation/navigationSlice";
import useStyles from "./AppDrawer.styles";
import NavigationLink from "./NavigationLink";
import { NavLink, getBottomLinks, standardLinks } from "./links";

const Links = () => {
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const profile: Profile = useAppSelector(selectCurrentUser);
  const currentOrgID = useAppSelector(selectCurrentOrgID);
  const dispatch = useDispatch();
  const history = useHistory();

  const isDefaultOwner =
    profile.roles.includes("organization_owners") && !profile.organization;

  return (
    <List
      dense
      component={"nav"}
      className={!showDrawer ? classes.nav : undefined}
    >
      {(profile as any).organizationId !== currentOrgID && (
        <NavigationLink
          link={{
            name: "Admin view",
            path: "",
            icon: <ManageAccounts />,
            onClick: () => {
              dispatch(setCurrentOrgID(null));
              history.push("/grading/admin/organizations");
            },
          }}
        />
      )}

      {standardLinks
        .filter((link: NavLink) => {
          if (
            isDefaultOwner &&
            currentOrgID !== null &&
            link.path === "/grading/organization"
          )
            return true;

          if (
            isDefaultOwner &&
            currentOrgID !== null &&
            link.path === "/grading/admin/organizations"
          )
            return false;

          if (isDefaultOwner && link.path !== "/grading/organization")
            return true;

          if (!isDefaultOwner && link.path !== "/grading/admin/organizations")
            return true;

          return false;
        })
        .map((link: NavLink, i: number) => (
          <NavigationLink key={`${link.name}-${i}`} link={link} />
        ))}
    </List>
  );
};

const BottomLinks = () => {
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const profile: Profile = useAppSelector(selectCurrentUser);
  const bottomLinks = getBottomLinks(profile?.unreadMessagesCount || 0);
  return (
    <List dense component={"nav"} className={classes.bottomLinks}>
      {bottomLinks.map((link: NavLink, i: number) => (
        <NavigationLink key={`${link.name}-${i}`} link={link} />
      ))}
    </List>
  );
};

const AppDrawer = () => {
  const theme = useTheme();
  const showDrawer = useAppSelector(selectShowDrawer);
  const classes = useStyles(showDrawer)();
  const dispatch = useAppDispatch();

  return (
    <nav className={classes.root}>
      <IconButton
        className={classes.toggleButton}
        onClick={() => {
          dispatch(toggleDrawer());
        }}
      >
        {showDrawer ? (
          <Remove style={{ fill: theme.palette.secondary.light }} />
        ) : (
          <Add style={{ fill: theme.palette.secondary.light }} />
        )}
      </IconButton>

      {showDrawer ? (
        <>
          <img
            src="/logo_white_background.png"
            style={{
              objectFit: "contain",
              width: "110px",
              height: "56px",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: theme.spacing(7),
              marginBottom: theme.spacing(2),
            }}
            alt="readyfit-logo"
          />
        </>
      ) : (
        <img
          src="/mini_logo_white_background.png"
          alt="mini_logo_white_background"
          style={{
            objectFit: "contain",
            width: "56px",
            height: "26px",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(7),
          }}
        />
      )}

      <Links />

      <BottomLinks />
    </nav>
  );
};

export default AppDrawer;
